<template>
  <super-admin-layout>
    <v-container fluid style="margin-bottom: 0px">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            class="search-box"
            placeholder="Search Partners"
            prepend-icon="fa-search"
            v-model="search"
            type="text"
            clearable
            clear-icon="fa-times"
            @click:clear="resetSearch"
            @keyup="applySearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
              <v-select :items="status" :clearable="true" placeholder="Status" item-value="id" item-text="name"
                v-on:change="FilterByStatus($event)" class="search-box"></v-select>
        </v-col>
        <v-col cols="12" md="6" class="partner-button-wrapper">
          <v-btn
            class="mr-1"
            color="primary"
            @click.prevent="showCreatePartnerPanel"
            outlined
          >
            <v-icon class="pr-2">fa-plus</v-icon>Add Partner
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="computedHeaders"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="partners"
              item-key="id"
            >
              <template v-slot:item.id="{ item }">
                <v-btn color="primary" :to="'/super-admin/partner/' + item.id"
                  >Details
                </v-btn>
                <span>&nbsp;</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="item.state == 4"
                      :id="item.id"
                      v-on="on"
                      outlined
                      small
                      color="secondary"
                      @click.prevent="showEditPanel(item.id)"
                    >
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.state != 4">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="error"
                      class="ml-1"
                      outlined
                      small
                      @click.prevent="updateState(item.id, 'suspend')"
                    >
                      <v-icon small>fa fa-ban</v-icon>
                    </v-btn>
                  </template>
                  <span>Suspend Partner</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="error"
                      class="ml-1"
                      outlined
                      small
                      @click.prevent="updateState(item.id, 'active')"
                    >
                      <v-icon small>fa fa-undo</v-icon>
                    </v-btn>
                  </template>
                  <span>Active Partner</span>
                </v-tooltip>
              </template></v-data-table
            >
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from '@/layouts/SuperAdmin';
import CreatePartner from '@/components/superadmin/partners/Create';
import EditPartner from '@/components/superadmin/partners/Edit';
import partnerAPI from '@/api/partner.js';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'SuperAdminPartnerList',
  components: {
    SuperAdminLayout,
  },
  data() {
    return {
      headers: [
        { text: 'Partner', value: 'company_name' },
        { text: 'First Name', value: 'first_name', sortable: false },
        { text: 'Surname', value: 'last_name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'State', value: 'state_description', sortable: false },
        { text: 'Created On', value: 'created_at' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        { text: '', value: 'id', align: 'end', sortable: false },
      ],
      partners: [],
      search: '',
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      confirmDelete: 'Are you sure you wish to delete this partner?',
      confirmUpdatePartnerState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
      status: [
        { id: 1, name: 'Live' },
        { id: 4, name: 'Suspended' },
      ],
      selectedStatus: "",
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.$globalConfig.APP_NAME == 'senso') {
        headers.splice(5, 0,
          { text: 'Level', value: 'level', sortable: false },
        );
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getPartnersCompany();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
    this.loadSearch();
  },
  methods: {
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams =
          '&search=users.first_name:' +
          this.search +
          ';users.last_name:' +
          this.search +
          ';company_name:' +
          this.search;
      } else {
        this.searchParams = '';
      }
      this.getPartnersCompany();
      this.saveSearch();
      }, 1000);
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '';
      this.applySearch();
      this.saveSearch();
    },
    getPartnersCompany() {
      this.loading = true; //alert(this.params);
      partnerAPI
        .getPartners(this.params + '&level=all', this.searchParams, 0, this.selectedStatus)
        .then((resp) => {
          this.partners = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditPartner,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreatePartnerPanel() {
      this.$showPanel({
        component: CreatePartner,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('PARTNER_UPDATED', (payload) => {
        // this.params = payload;
        this.getPartnersCompany();
      });
    },
    updateState(id, state = '') {
      var confirmUpdatePartnerState =
        this.confirmUpdatePartnerState + state + '?';
      this.$snotify.confirm(confirmUpdatePartnerState, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processUpdatePartnerState(toast, id, state),
          }         
        ],
      });
    },
    processUpdatePartnerState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;

      partnerAPI.updatePartnerState(id, state).then(() => {
        this.getPartnersCompany();
        this.$snotify.success(this.successUpdateStateMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    saveSearch() {
      // Save search value to localStorage
      if (this.search && this.search.length > 0) {
        localStorage.setItem('search-partner', this.search);
      } else {
        localStorage.removeItem('search-partner');
      }
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('search-partner');
      if (savedSearch !== null) {
        this.search = savedSearch;
        this.searchParams =
          '&search=users.first_name:' +
          this.search +
          ';users.last_name:' +
          this.search +
          ';company_name:' +
          this.search;
      }
    },
    FilterByStatus(status) {
      if (typeof status != 'undefined' && status !== null)
        this.selectedStatus = '&state=' + status;
      else
        this.selectedStatus = '';

      this.getPartnersCompany();
    },
  },
};
</script>
